/**
 * บันทึกรูปลงเครื่องผู้ใช้
 *
 * เว็บเขียนไฟล์ลง Photos/gallery โดยตรงไม่ได้ ไม่มี API ให้ทำ ทางที่ใกล้เคียงที่สุด
 * คือ Web Share API ซึ่งเปิด share sheet ของระบบขึ้นมาให้ผู้ใช้แตะ "บันทึกรูปภาพ" เอง
 * รองรับ iOS Safari 15+ เครื่องเก่ากว่านั้นตกกลับไปใช้ <a download> แบบเดิม
 * ซึ่งบน iOS ไม่ค่อยได้ผล ผู้ใช้ยังกดค้างที่รูปเพื่อบันทึกได้อยู่
 */
export function useSaveImage() {
  /**
   * แปลง data URI เป็น File โดยไม่ใช้ fetch()
   * fetch('data:...') จะถูก CSP บล็อก เพราะ connect-src ไม่มี data:
   */
  const dataUrlToFile = (src, filename) => {
    const [header, base64] = src.split(',');
    const mime = header.match(/data:([^;]+)/)?.[1] || 'image/png';
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new File([bytes], filename, { type: mime });
  };

  const urlToFile = async (src, filename) => {
    if (src.startsWith('data:')) {
      return dataUrlToFile(src, filename);
    }
    // path ปกติเป็น same-origin จึงผ่าน connect-src 'self'
    const response = await fetch(src);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type || 'image/png' });
  };

  const downloadViaAnchor = (src, filename) => {
    const link = document.createElement('a');
    link.href = src;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /**
   * คืนค่าเป็นผลลัพธ์ที่เกิดขึ้นจริง เพื่อให้ผู้เรียกและเทสต์ตรวจสอบได้
   * 'shared' | 'cancelled' | 'downloaded' | 'skipped'
   */
  const saveImage = async (src, filename) => {
    if (!src) return 'skipped';

    try {
      const file = await urlToFile(src, filename);
      if (navigator.canShare?.({ files: [file] })) {
        try {
          await navigator.share({ files: [file] });
          return 'shared';
        } catch (error) {
          // ผู้ใช้ปิด share sheet เอง ถือว่าจบ อย่าเด้ง download ซ้อนขึ้นมาอีก
          if (error?.name === 'AbortError') return 'cancelled';
          // share ล้มเหลวจริง ค่อยตกกลับไปดาวน์โหลด
        }
      }
    } catch {
      // แปลงไฟล์ไม่สำเร็จ ตกกลับไปดาวน์โหลดตามปกติ
    }

    downloadViaAnchor(src, filename);
    return 'downloaded';
  };

  return { saveImage };
}
